<script>
    import Textfield, {Input, Textarea} from '@smui/textfield';
    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';

    export let value = "";
    export let label = "Title";
    export let help;
    export let options = {};
    export let icon = "label";
    export let style;
    export let fullwidth = true;
    export let textarea;
    export let leadingIcon = !textarea;
    export let type;
    export let disabled;

    const clearValueIconClickMargin = 40;

    $: calculatedStyle = `
        ${style};
        ${fullwidth ? "width: 100%;" : ""}
    `;

    // the icon is under the top element and it doesnt catch a click.
    // so we catch the click manually and check if its in the bounds
    // of the icon, then we emulate a click.
    function onClick(evt) {
        let elementDimensions = evt.target.getBoundingClientRect();
        if (value && evt.offsetX >= (elementDimensions.width - clearValueIconClickMargin)) {
            console.log(`Icon for clearing field clicked. Clearing value '${value}'`);
            value = "";
        }
    }
</script>

<Textfield
        withLeadingIcon={leadingIcon}
        withTrailingIcon
        variant="outlined"
        on:click={onClick}
        bind:value={value}
        {label}
        {...options}
        {disabled}
        style={calculatedStyle}
        {textarea}
        {type}
        input$aria-controls="helper-text-persistent-c"
        input$aria-describedby="helper-text-persistent-c" >
    {#if leadingIcon}
        <Icon class="material-icons">{icon}</Icon>
    {/if}
<!--    <Icon class="material-icons">delete</Icon>-->
</Textfield>

<HelperText id="helper-text-persistent-c" persistent>
    {#if help}
        {help}
    {:else}
        <slot name="help">

        </slot>
    {/if}
</HelperText>